/**
 * Función que oculta los contenedores de las preguntas
 */
const hideAll = () => {
    const allGuides = document.querySelectorAll('div[id*=sg]');
    allGuides.forEach((guide) => {
        guide.classList.add('u-hidden');
        scrollTo(0, 0);
    });
};

const showAllOptions = (n) => {
    const allGuidesOptions = document.querySelectorAll(`[id*=containerOption_]`);
    allGuidesOptions.forEach((guideOptions) => {
        guideOptions.classList.remove('u-hidden');
    });
};
 
window.addEventListener('scroll', (e) => { 
    var offSetBottom =  $(window).scrollTop() - $('#solutionGuide').offset().top - $('#solutionGuide').height() + $(window).height();
    console.log("__:_-",offSetBottom);
    if (offSetBottom > 0) {
        document.getElementById('ButtonsSteps').classList.add('sticky');
    } else {
        document.getElementById('ButtonsSteps').classList.remove('sticky');
    }
});

window.addEventListener("load", function () {
    progressBar();
    if (document.getElementById("solutionGuide").classList.contains("sgBrandLeo") == true) {
        document.getElementById("MainContent").style.backgroundColor = "#F5F5F5";
    } else if (document.getElementById("solutionGuide")) {
        document.getElementById("MainContent").style.backgroundColor = "#F5ECE8";
    }
});

const progressBar = function () {
  var numberQuestions = document.querySelectorAll('div[id*=sg]').length;
  var progress = state.current_questionid;
  var prueba = document.querySelectorAll('div[id*=sg]');
  for (var i=0; i<prueba.length;i++) {
    var ttt = prueba[i].classList.contains("u-hidden");
    if (ttt == false) {
      var questionNumber = document.querySelectorAll('div[id*=sg]')[i].getAttribute('data-question-number');
      var totalProgress = 100 - ((numberQuestions - questionNumber) / numberQuestions) * 100;
      document.getElementById("ProgressBar").style.width= totalProgress+"%";
    }
  }
  var getClassSummary = document.getElementById("sgsummary").classList.contains("u-hidden");
  if (getClassSummary == false) {
    document.getElementById("ProgressBar").style.width = "100%";
  }
}

/*window.addEventListener("load", (event) => {
  var numberQuestion = `${shop.metafields.guides[section.settings.sg_type].sg_questions}`;
  console.log("ID__:", numberQuestion);
});*/

/**
 * Función que configura el evento para mostrar el contenedor de la pregunta 
 * referenciado por next_questionid de cada elem button
 */
document.querySelectorAll('input[name*=sg]').forEach(
    (elem) => {
        elem.addEventListener('input', () => {
            state.setNextQuestionid(elem.dataset['next_questionid']);
            state.setDisableNextOptions(elem.dataset['disable_next_options']);
            state.setCurrentQuestionid(elem.dataset['current_questionid']);
            state.setBreak(elem.dataset['break']);
            document.getElementById(`next${elem.dataset['current_questionid']}`).disabled = false;
            document.getElementById(`next${elem.dataset['current_questionid']}`).style.opacity = "1";
            getNumberCheck(elem);
        });
        elem.addEventListener('click', () => {
          //showAllOptions();
          const allGuidesOp = document.querySelectorAll(`[id*=containerOption_${state.next_questionid}]`);
          allGuidesOp.forEach((guideOp) => {
              guideOp.classList.remove('u-hidden');
          });

              //allGuidesOptions.classList.remove('u-hidden');
            for (i=0;i<document.querySelectorAll(`[id*=containerOption_${state.next_questionid}]`).length;i++) {
              document.querySelectorAll(`[id*=containerOption_${state.next_questionid}_]`)[i].classList.remove('u-hidden');
            }
          if (state.disable_next_options != '') {
            const disable_next_options = state.disable_next_options.split(',');
            disable_next_options.forEach((option) => {
              //document.getElementById(`containerOption_${option}`).classList.add('u-hidden');
              document.getElementById(`containerOption_${option}`).classList.add('u-hidden');
              //document.getElementById(`sg${state.next_questionid}`).classList.remove('u-hidden');
              console.log("__1_",state.disable_next_options);
            });
          }  
          getNumberCheck(elem);
        });
    }
);

/**
 * función que valida el número de respuestas seleccionada y cambia el comportamiento del botón
 */
function getNumberCheck(elem) {
    var sgQuestion = document.querySelectorAll('[name="'+elem.name+'"]');
    var sgNumberQuestion = elem.getAttribute('data-current_questionid');
    var checkCount = 0;
    for (var k=0; k<sgQuestion.length; k++) {
      if (sgQuestion[k].checked) {
        checkCount = checkCount + 1;
      }
    }
    if (checkCount<1) {
      document.getElementById('next'+sgNumberQuestion).disabled = true;
      document.getElementById('next'+sgNumberQuestion).style.opacity = '0.3';
    } else {
        document.getElementById('next'+sgNumberQuestion).disabled = false;
        document.getElementById('next'+sgNumberQuestion).style.opacity = '1';
    }
}

/**
 * función que configura el evento para el botón atras
 */
document.querySelectorAll('span[id*=back]').forEach(
    (back) => {
        back.addEventListener('click', () => {
            //showAllOptions();
            //hideAll();
            if (state.disable_next_options != '') {
                const disable_next_options = state.disable_next_options.split(',');
                disable_next_options.forEach((option) => {
                    //console.log("_____",document.getElementById(`containerOption_${option}`));
                    document.getElementById(`containerOption_${option}`).classList.remove('u-hidden');
                });
            }
            //hideAll();
            document.getElementById(`sg${state.current_questionid}`).classList.remove('u-hidden');
            hideAll();
            document.querySelectorAll(`input[name=sg${back.dataset['backto']}`).forEach(
                (elem) => {
                    elem.checked = false;
                    document.getElementById(`next${elem.dataset['current_questionid']}`).disabled = true;
                    document.getElementById(`next${elem.dataset['current_questionid']}`).style.opacity = "0.3";
                }
            );
            document.querySelectorAll(`input[name=sg${state.current_questionid}`).forEach(
                (elem) => {
                    elem.checked = false;
                    document.getElementById(`next${elem.dataset['current_questionid']}`).disabled = true;
                    document.getElementById(`next${elem.dataset['current_questionid']}`).style.opacity = "0.3";
                }
            );
            document.getElementById(`sg${back.dataset['backto']}`).classList.remove('u-hidden');
            //
            progressBar();
        });
    }
);

/**
 * función que configura el evento para el botón siguiente
 */
//document.querySelectorAll(`next${state.current_questionid}`).forEach(
document.querySelectorAll('button[id*=next]').forEach(
    (next) => {
        next.addEventListener('click', () => {
        //document.getElementById(`containerOption_${option}`).addEventListener('click', () => {
          //showAllOptions();
          const allGuidesOp = document.querySelectorAll(`[id*=containerOption_${state.next_questionid}]`);
          allGuidesOp.forEach((guideOp) => {
              guideOp.classList.remove('u-hidden');
          });
          hideAll();
          document.getElementById(`sg${state.next_questionid}`).classList.remove('u-hidden');
          console.log("__1_",state.disable_next_options); 
          console.log("_2__",state.disable_next_options); 
          if (state.next_questionid == 'summary' || state.break == 'true') {
              summary();
          }
          else {
              // se deben ocultar las opciones  relacionadas en  data-disable_next_options
              if (state.disable_next_options != '') {
                  const disable_next_options = state.disable_next_options.split(',');
                  disable_next_options.forEach((option) => {
                      document.getElementById(`containerOption_${option}`).classList.add('u-hidden');
                      document.getElementById(`sg${state.next_questionid}`).classList.remove('u-hidden');
                  });
              } 
              document.getElementById(`back${state.next_questionid}`).dataset['backto'] = state.current_questionid;
          }
          ;
          progressBar();
        });
    }
);

/**
 * Función que construye los parámetros para la redirección a la página de resultados
 */
const searchBuild = function () {
    const searchParams = new URLSearchParams();
    document.querySelectorAll('input[name*=sg]:checked').forEach(
        (elem) => {
            searchParams.append(elem.dataset['question'], elem.value);
        }
    );
    const url = `${window.location.origin}${window.Shopify.routes.root}collections/${theme.SG_collectionHandle}?${searchParams.toString()}&utm_source=web&utm_medium=solutionguide&utm_campaign=${theme.SG_collectionHandle}`;
     //document.querySelector('[id^="Resultados_Solution_Guide_"]').type = 'hidden';
    //document.querySelector('[id^="solution_guide_type_"]').type = 'hidden';
    $(('[id^="Resultados_Solution_Guide_"]')).val(url);
    var getSGType = theme.SG_type;
    if ((getSGType == 'active') || (getSGType == 'shapewear')) {
        $("li.u-padEnds .sg-number").css({
            "display": "none"
        });
    }
    //console.log("RESP", test);
    $('.sg-skipbutton')[0].href = url
};

/**
 * Clase que representa una opción seleccionada
 * @param {integer} question_id es el id de la pregunta
 * @param {string} selected_option es el texto de la opción seleccionada
 */
class selectedOption {

    constructor(question_id, selected_option) {
        this.question_id = question_id;
        this.selected_option = selected_option;
    }

    ToString() {
        return `<li class="u-padEnds">
                    ${this.selected_option}
                </li>`;
    }

}

/**
 * Clase para gestionar los estados next_questionid, disable_next_options, break y current_questionid
 */

class stateClass {
    constructor() {
        this.next_questionid = 0;
        this.disable_next_options = [];
        this.current_questionid = 0;
        this.break = false;
    }

    setNextQuestionid(next_questionid) {
        this.next_questionid = next_questionid;
    }

    setDisableNextOptions(disable_next_options) {
        this.disable_next_options = disable_next_options;
    }
    
    setCurrentQuestionid(current_questionid) {
        this.current_questionid = current_questionid;
    }

    setBreak(break_status) {
        this.break = break_status;
    }

}

//Inicializa la clase state

var state = new stateClass();

/**
 * Función que construye el resumen de las opciones seleccionadas
 */
const summary = () => {
    const summary = document.getElementById('summaryContainer');
    const selectedOptions = [];
    document.querySelectorAll('input[name*=sg]:checked').forEach(
        (elem) => {
            selectedOptions.push(new selectedOption(elem.dataset['current_questionid'], elem.dataset['answer']));
        }
    );
    summary.innerHTML = selectedOptions.map((option) => option.ToString()).join('');
    searchBuild();
}

/**
 * Implementado desde https://developers.klaviyo.com/en/docs/track-klaviyo-form-activity-using-javascript
 */
window.addEventListener("klaviyoForms", function (e) {
    console.log(e.detail);
    const searchParams = new URLSearchParams();
    document.querySelectorAll('input[name*=sg]:checked').forEach(
        (elem) => {
            searchParams.append(elem.dataset['question'], elem.value);
        }
    );
    const url = `${window.location.origin}${window.Shopify.routes.root}collections/${theme.SG_collectionHandle}?${searchParams.toString()}&utm_source=web&utm_medium=solutionguide&utm_campaign=${theme.SG_collectionHandle}`;
    /**
     * https://developers.klaviyo.com/en/v1-2/docs/javascript-api#api-basics
     * se debe enviar la url en el campo de klaviyo
     */
    //Identify a user
    _learnq.push(['identify', {
        'Resultados Solution Guide': url,
        'solution_guide_type': theme.SG_type
    }]);
    if (e.detail.type == 'submit') {

        window.location.href = url;
        
        
    }

    searchBuild();

});


